import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';

const FormFieldContext = createContext({});
const FormItemContext = createContext({});

export function Form({ children, ...props }) {
  return <form {...props}>{children}</form>;
}

export function FormField({ name, children }) {
  return (
    <FormFieldContext.Provider value={{ name }}>
      <fieldset className="border-0 p-0 mb-0">
        {children}
      </fieldset>
    </FormFieldContext.Provider>
  );
}

export function FormItem({ children, className = '' }) {
  const { name } = useContext(FormFieldContext);
  return (
    <FormItemContext.Provider value={{ name }}>
      <div className={className}>
        {children}
      </div>
    </FormItemContext.Provider>
  );
}

export function FormLabel({ children, required, className = '' }) {
  const { name } = useContext(FormFieldContext);
  return (
    <label
      htmlFor={name}
      className={`block mb-1 text-sm font-bold text-gray-700 ${className}`}
    >
      {children}
      {required && <span className="text-coit-error ml-1">*</span>}
    </label>
  );
}

export function FormControl({ children }) {
  return children;
}

export function FormDescription({ children, className = '' }) {
  return (
    <div className={`text-sm mb-0 ${className}`}>
      {children}
    </div>
  );
}

export function FormFieldErrorMessage({ error, className = '' }) {
  const { name } = useContext(FormFieldContext);

  if (!error) return null;

  return (
    <div
      id={name ? `${name}-error` : undefined}
      role="alert"
      className={`text-sm mb-0 text-coit-error ${className}`}
    >
      {error}
    </div>
  );
}
